/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Machine_Id_PlaceholderInputs */

const en_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Machine Id`)
};

const fr_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant machine hors ligne`)
};

const de_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Maschinen-ID`)
};

const it_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID macchina offline`)
};

const ru_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор автономного устройства`)
};

const es_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. de máquina sin conexión`)
};

const zh_cn2_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线机器 ID`)
};

const ja_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインマシンID`)
};

const hi_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन मशीन आईडी`)
};

const pt_pt2_offline_activation_machine_id_placeholder = /** @type {(inputs: Offline_Activation_Machine_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da máquina offline`)
};

/**
* | output |
* | --- |
* | "Offline Machine Id" |
*
* @param {Offline_Activation_Machine_Id_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_machine_id_placeholder = /** @type {((inputs?: Offline_Activation_Machine_Id_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Machine_Id_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_machine_id_placeholder(inputs)
	if (locale === "de") return de_offline_activation_machine_id_placeholder(inputs)
	if (locale === "it") return it_offline_activation_machine_id_placeholder(inputs)
	if (locale === "ru") return ru_offline_activation_machine_id_placeholder(inputs)
	if (locale === "es") return es_offline_activation_machine_id_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_machine_id_placeholder(inputs)
	if (locale === "ja") return ja_offline_activation_machine_id_placeholder(inputs)
	if (locale === "hi") return hi_offline_activation_machine_id_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_machine_id_placeholder(inputs)
	return en_offline_activation_machine_id_placeholder(inputs)
});